import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { AgenciesContent } from "@/components/pages/agencies/Agencies";
import { queryAvisRentACar } from "@/strapiQuery/avis-rent-a-car";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";
import { Reviews } from "@/components/pages/avisRentACar/allReviews/AllReviews";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { NetworkError } from "@/interfaces/errors/networkError";
import { page404 } from "@/const/page404";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const avisRentACarContentPromise = getStrapiEntity<AgenciesContent>(
    "avis-rent-a-car",
    queryAvisRentACar
  );

  const reviewsConstPromise = getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  let reviews: Reviews;
  try {
    reviews = await sendFetchRequest(
      "/globalReview/v1/global-review?count=40"
    ).then((json: Reviews) => json);
  } catch (error) {
    if (error instanceof NetworkError) {
      return page404;
    }
    throw error;
  }

  const [layout, avisRentACarContent, reviewsConst] = await Promise.all([
    layoutPromise,
    avisRentACarContentPromise,
    reviewsConstPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...avisRentACarContent,
      reviewsConst,
      reviews,
      intlMessages,
      defaultCanonicalRoute: routes.agencies,
    },
    revalidate: 10,
  };
};

export { AvisRentACar as default } from "@/components/pages/avisRentACar/AvisRentACar";
